import { InjectionToken } from '@angular/core';


/**
 * @deperecated Not necessary anymore for verticals using the frontend-container.
 */
export enum MmuAppContext {
  ACTIONS = 'actions',
  PAGES = 'pages',
  PAYMENT = 'payment',
  SERVICE = 'service',
  SUPPORT = 'support',
  CONTAINER = 'container'
}

/**
 * The App context defines in which app (or vertical) the utility components of this library are being used. It must be provided
 * by any consuming application, because some utility components such as the main menu behave differently depending on the app it
 * is used in.
 * @deperecated Not necessary anymore for verticals using the frontend-container.
 */
export const MMU_APP_CONTEXT = new InjectionToken<MmuAppContext>('MMU_APP_CONTEXT');
